import TicketIcon from "@heroicons/react/24/solid/TicketIcon";
import DiscountCard from "@/components/views/venue-details/card/discount/DiscountCard";
import { VENUE_TABS } from "@/@core/constants/venue-tabs";
import { useRef } from "react";
import { useTranslation } from "@/hooks/translationContext";
import { GLOBAL_VENUE_DISCOUNT_DESCRIPTION_KEY, GLOBAL_VENUE_DISCOUNT_PERCENT_KEY } from "@/@core/constants/discount";

interface Props {
  datas: {
    percent: number;
    descriptions: [
      {
        title: string;
        description: string;
      },
    ];
  }[];
  phone: string;
  company: boolean;
}

export default function DiscountCardBody(props: Props) {
  const discountRef = useRef(null);
  const { t } = useTranslation()

  const onClickDescription = () => {
    if (props.company) {
      const targetElement = document.getElementById("company-discounts");
      const position = targetElement?.getBoundingClientRect();
      if (!position) return;

      window.scrollTo(position.left, position.top + window.scrollY - 100);
    }
  };

  const globalDiscountPercent = t(GLOBAL_VENUE_DISCOUNT_PERCENT_KEY)
  const globalDiscountDescription = t(GLOBAL_VENUE_DISCOUNT_DESCRIPTION_KEY)

  const getDiscountCount = () => {
    if (props.datas.length == 0) {
      return globalDiscountPercent !== GLOBAL_VENUE_DISCOUNT_PERCENT_KEY ? 1 : 0;
    }

    return props.datas.length;
  }

  const activeDiscounts = props.datas.find(d => d?.percent == 0);
  if (activeDiscounts) return null;

  return (
    <>
      {/* {props.datas && ( */}
      <div
        id={VENUE_TABS.DISCOUNTS}
        className="flex flex-col mt-6 mb-6 lg:max-w-[895px] border rounded-[32px] px-4 pt-4 pb-2 gap-4 relative"
      >
        <div className="flex w-full items-start flex-col gap-2">
          <div className="w-full flex bg-stone-50 rounded-[16px] py-1.5 px-2 gap-2">
            <TicketIcon className="size-5 text-primary" />
            <h2 className="text-primary font-bold text-sm">İndirimler</h2>
            <div className="py-[2px] cursor-default px-[6px] text-xs bg-primary text-white font-[500] rounded-full">
              {getDiscountCount()}
            </div>
          </div>

          <button
            role="button"
            disabled={!props.company}
            className={`text-slate-800 text-sm gap-1 flex md:flex-row flex-col ${!props.company ? "cursor-default" : "cursor-pointer"
              }`}
            onClick={props.company ? onClickDescription : undefined}
          >
            <span className="text-slate-800 md:text-sm text-xs">
              {t("venue-detail-discount-description")}
            </span>

            {props.company ? (
              <span className="text-slate-800 md:text-sm text-xs">
                {t("venue-detail-discount-description-with-company-discount")}
              </span>
            ) : (
              <></>
            )}
          </button>
        </div>

        <div
          ref={discountRef}
          className="grid grid-cols-1 md:grid-cols-2 gap-4 pb-2"
        >
          {props.datas.map((discount: any, index: number) => {
            return (
              <DiscountCard
                {...props}
                phone={props.phone}
                key={index}
                percent={discount.percent}
                description={discount.descriptions[0]?.description}
                title={discount.descriptions[0]?.title}
              />
            );
          })}

          {!props.datas.length && globalDiscountPercent !== GLOBAL_VENUE_DISCOUNT_PERCENT_KEY && (
            <DiscountCard
              {...props}
              phone={props.phone}
              percent={globalDiscountPercent}
              description={globalDiscountDescription}
              title={""}
            />
          )}
        </div>
      </div>
      {/* )} */}
    </>
  );
}
